
<template>
    <li class="tcu-directory-card tcu-directory-card__content">
        <div class="group">
          <span class="tcu-profile-list__name | tcu-directory-card__name"><a ref="focusEl" :href="userLink" v-on:click.prevent :data-href="card.source" @click="selectProfile">{{ card.name }}</a></span><br />
          <span class="tcu-profile-list__title">{{ card.jobTitle }}</span>
        </div>
        <span class="tcu-profile-list__email | tcu-directory-card__icon">
          <template v-if="card.email">
            <svg class="tcu-email-icon" focusable="false" height="24" width="24"><use xmlns:xlink="http://www.w3.org/1999/xlink" href="#icon-email-icon" xlink:href="#icon-email-icon"></use></svg>
            <a v-if="card.email" v-on:click.stop :href="'mailto:' + card.email">{{ card.email }}</a>
          </template>
        </span>
        <span class="tcu-profile-list__telephone | tcu-directory-card__icon">
          <template v-if="card.telephone">
            <svg class="tcu-phone-icon" focusable="false" height="24" width="24"><use xmlns:xlink="http://www.w3.org/1999/xlink" href="#icon-phone-icon" xlink:href="#icon-phone-icon"></use></svg>
            {{ card.telephone }}
          </template>
        </span>
    </li>
</template>
<script>
import store from '../store';
export default {
  data() {
    return {
      // list of tags for giving each schools a different color - maybe a feature later
    };
  },

  props: {
    // this component expects a prop of type object
    card: Object,
    focused: Boolean
  },
  mounted(){
    if(this.focused) {
      this.$refs.focusEl.focus();
    }
  },
  computed: {
    userLink() {
      return store.config.profilePath + '/' + this.card.filename;
    }
  },
  methods: {
    selectProfile( event ) {
      event.preventDefault();
      this.$emit('selectProfile', this.card)
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ProfileList.vue